import React, { useEffect } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  Dropdown as DropdownUI,
  IDropdownOption,
} from "office-ui-fabric-react/lib/Dropdown";

import CustomDialog from "~/components/CustomDialogFluentUI";
import {
  TitleField,
  GroupItems,
  GroupItemUmTerco,
  GroupItemDoisTerco,
} from "~/components/FormGroup";
import { InputText } from "~/components/Forms";
import { TaskAvaliacaoColetivaSelected } from "~/store/ducks/tasks/types";
import { Creators } from "~/store/ducks/tasks";
import {
  DefaultButton,
  Icon,
  Spinner,
  SpinnerSize,
  Stack,
} from "office-ui-fabric-react";

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "~/store/ducks";
import { PrimaryButton } from "~/components/Buttons";
import Colors from "~/assets/js/colors";

const validationSchema = yup.object().shape({
  resultadometas: yup.string().required("Campo obrigatório"),
  comentariosMetas: yup.string().notRequired(),
});

interface IDialogPerformanceProps {
  isOpen: boolean;
  idTarefa: number | null;
  idTarefaAvaliacao: number;
  nomeCompleto: string;
  //initialValues: CalibrationValues;
  loadingData: boolean;
  success: boolean;
  //performances: TabPerfomanceType[];
  readonly: boolean;
  modoHidden?: boolean;
  onClose: () => void;
  onSuccess: (values: any) => void;
}

const initial = {
  resultadometas: "",
  comentariosMetas: "",
};

const DialogPerformance: React.FC<IDialogPerformanceProps> = (props) => {
  const {
    isOpen,
    onClose,
    onSuccess,
    idTarefa,
    idTarefaAvaliacao,
    nomeCompleto,
    loadingData,
    
    readonly,
    //performances,
    //initialValues,
  } = props;
  const dispatch = useDispatch();
  const avaliacao = useSelector<
    RootState,
    TaskAvaliacaoColetivaSelected | null
  >((state) => state.tasksReducer.selectedColetiva);

  useEffect(() => {
    if (idTarefa && idTarefaAvaliacao) {
      dispatch(Creators.getInfoAvaliacaoColetiva(idTarefa, idTarefaAvaliacao));
    }
  }, [idTarefa, idTarefaAvaliacao]);

  useEffect(() => {
    resetForm({
      values: {
        resultadometas: avaliacao?.resultadometas ?? "",
        comentariosMetas: avaliacao?.comentariosMetas ?? "",
      },
    });
  }, [avaliacao]);

  // useEffect(() => {
  //   if (success && isOpen) {
  //     resetForm();
  //   }
  // }, [success, isOpen]);

  const onRenderTitle = (options: IDropdownOption[]): JSX.Element => {
    const option = options[0];

    return (
      <Stack horizontal verticalAlign="center">
        {option.data && option.data.icon && (
          <Icon
            iconName={option.data.icon}
            aria-hidden="true"
            title={option.data.icon}
            styles={{ root: { ...option.data.style, marginRight: 10 } }}
          />
        )}
        <Stack>
          <span
            style={{
              fontSize: 12,
              whiteSpace: "break-spaces",
              lineHeight: 1.5,
              textAlign: "left",
              ...option.data.styleOption,
            }}
          >
            {option.text}
          </span>
        </Stack>
      </Stack>
    );
  };

  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    resetForm,
    setFieldValue,
    setFieldError,
  } = useFormik({
    initialValues: initial,
    validationSchema,
    validateOnBlur: true,
    validateOnChange: false,
    onSubmit(values) {
      onSuccess(values);
    },

    // onSubmit(values) {
    //   const performance: PerformanceAvaliado = {
    //     carreira: values.carreira,
    //     proximoCiclo: values.proximoCiclo,
    //     idTabPerformance: Number(values.idTabPerformance),
    //     performance: performances.find(
    //       (item) => item.idTabPerformance === Number(values.idTabPerformance)
    //     ),
    //     potencial: values.potencial,
    //     sucessao:
    //       values.sucessao !== "" && values.sucessao !== "blank"
    //         ? values.sucessao
    //         : null,
    //   };
    //   onSuccess({ ...performance, comentarios: values.comentarios });
    // },
  });

  // useEffect(() => {
  //   if (isSubmitting) {
  //     if (!isValid) {
  //       setErrorForm(true);
  //     } else {
  //       setErrorForm(false);
  //     }
  //   }
  // }, [isSubmitting, isValid]);

  return (
    <CustomDialog
      hidden={!isOpen}
      title="Avaliação da Performance"
      minWidth={640}
      minHeight={420}
      onRender={
        <>
          {loadingData ? (
            <Spinner
              size={SpinnerSize.medium}
              label="Carregando avaliado"
              styles={{ root: { height: 284 } }}
            />
          ) : (
            <form onSubmit={handleSubmit}>
              <GroupItemDoisTerco>
                <GroupItems title="Funcionário" titleRegular>
                  <TitleField text={nomeCompleto} bold />
                </GroupItems>
              </GroupItemDoisTerco>
              <GroupItems
                noMargins
                stylesWrapperItems={{
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <GroupItemUmTerco>
                  <TitleField text="AVALIAÇÃO" />
                </GroupItemUmTerco>
                <GroupItemDoisTerco width={360}>
                  <DropdownUI
                    placeholder="Selecione uma opção"
                    options={options}
                    defaultSelectedKey={
                      avaliacao?.resultadometas ?? "Selecione uma opção"
                    }
                    onRenderTitle={onRenderTitle as any}
                    disabled={readonly}
                    onChange={(e, item: IDropdownOption | any) => {
                      setFieldValue(`resultadometas`, item?.key);
                      setFieldError(`resultadometas`, "");
                    }}
                    styles={{
                      title: {
                        height: 60,
                        display: "flex",
                        alignItems: "center",
                        borderColor: errors.resultadometas
                          ? Colors.error
                          : "#CCCCCC",
                      },
                      caretDownWrapper: { top: 16 },
                    }}
                  />
                </GroupItemDoisTerco>
              </GroupItems>

              <InputText
                name="comentariosMetas"
                label="Comentários gerais"
                value={values.comentariosMetas ?? ""}
                onChange={(e: any) => {
                  handleChange(e);
                  setFieldError("comentariosMetas", "");
                }}
                multiline
                rows={5}
                rowsMax={5}
                error={errors.comentariosMetas ? true : false}
                helperText={errors.comentariosMetas}
                disabled={readonly}
                height_container={150}
              />
            </form>
          )}
        </>
      }
    >
      <DefaultButton
        onClick={() => {
          onClose();
          resetForm();
        }}
      >
        Cancelar
      </DefaultButton>
      <PrimaryButton
        onClick={() => handleSubmit()}
        // disabled={!avaliacao?.flagAutoAvaliacao}
      >
        Confirmar
      </PrimaryButton>
    </CustomDialog>
  );
};

const options: IDropdownOption[] = [
  {
    key: "Selecione uma opção",
    text: "Selecione uma opção",
    disabled: true,
    hidden: true,
    data: { styleOption: { fontSize: 14 } },
  },
  {
    key: "Acima da Expectativa",
    text: "ACIMA DA EXPECTATIVA",
    data: {
      icon: "SkypeCircleArrow",
      style: { color: Colors.blue, transform: "rotate(90deg)" },
    },
  },
  {
    key: "Dentro da Expectativa",
    text: "DENTRO DA EXPECTATIVA",
    data: { icon: "SkypeCircleCheck", style: { color: Colors.primary } },
  },
  {
    key: "Abaixo da Expectativa",
    text: "ABAIXO DA EXPECTATIVA",
    data: {
      icon: "SkypeCircleArrow",
      style: { color: Colors.error, transform: "rotate(-90deg)" },
    },
  },
];

export default DialogPerformance;
